import { FilterCondition } from "./filter-condition";

export class Filter {
  id!: number;
  name!: string;
  conditions!: FilterCondition[];
  values!: string[];
}